import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

// theming attributes - https://theme-generator.vuetifyjs.com/
Vue.use(Vuetify, {
  theme: {
    primary: '#d9241b',
    secondary: '#0a417c',
    accent: '#3f51b5',
    error: '#f44336',
    warning: '#ffc107',
    info: '#2196f3',
    success: '#4caf50'
  },
  iconfont: 'mdi',
})
